import React from 'react';
import { FormattedMessage } from 'react-intl';

const ErrorView = ({ error }) =>
    error && (
        <div className="show_warningMessage" id="warningMessage" role="alert">
            <p>
                <FormattedMessage id={error} />
            </p>
        </div>
    );

export default ErrorView;
